import { render, staticRenderFns } from "./BadgeNotify.vue?vue&type=template&id=928405ea&"
import script from "./BadgeNotify.vue?vue&type=script&lang=ts&"
export * from "./BadgeNotify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports